import { Link } from 'react-router-dom'
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    company: [
      { name: 'About Us', href: '/about' },
      { name: 'Mission & Vision', href: '/mission-vision' },
      { name: 'Our Team', href: '/about#team' },
      { name: 'Careers', href: '/careers' },
    ],
    products: [
      { name: 'All Products', href: '/products' },
      { name: 'Fertilizers', href: '/products?category=fertilizer' },
      { name: 'Organic Solutions', href: '/products?category=organic' },
      { name: 'Micronutrients', href: '/products?category=micronutrient' },
    ],
    resources: [
      { name: 'Events', href: '/events' },
      { name: 'Blog', href: '/blog' },
      { name: 'Support', href: '/support' },
      { name: 'Contact', href: '/about#contact' },
    ],
  }

  const socialLinks = [
    { name: 'Facebook', icon: Facebook, href: 'https://facebook.com/novatarracompany' },
    { name: 'Twitter', icon: Twitter, href: 'https://twitter.com/novatarra' },
    { name: 'Instagram', icon: Instagram, href: 'https://novatarra' },
  ]

  return (
    <footer className="bg-brand-blue text-white">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center space-x-3 mb-4">
              <img src="/logo.png" alt="Novatarra logo" className="h-8 w-8 object-contain" />
              <span className="text-2xl font-bold">Novatarra</span>
            </Link>
            <p className="text-gray-300 mb-4">
              Premium agricultural solutions for sustainable farming. Growing better yields with balanced nutrition and organic practices.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => {
                const Icon = social.icon
                return (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-olive hover:bg-sage-green p-2 rounded-lg transition-colors duration-200"
                    aria-label={social.name}
                  >
                    <Icon className="h-5 w-5" />
                  </a>
                )
              })}
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Products</h3>
            <ul className="space-y-2">
              {footerLinks.products.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin className="h-5 w-5 text-olive" />
                <span className="text-gray-300">
                  Burtnieku 39, Riga LV-1084 Latvia
                </span>
              </div>

              {
                1 > 2 ? <div hidden className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-olive" />
                  <span className="text-gray-300">(371) 123-4567</span>
                </div> : null
              }


              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-olive" />
                <span className="text-gray-300">info@novatarra.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/30 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              © {currentYear} Novatarra. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link
                to="/privacy"
                className="text-gray-300 hover:text-white text-sm transition-colors duration-200"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-gray-300 hover:text-white text-sm transition-colors duration-200"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
